import { render, staticRenderFns } from "./mediapage.vue?vue&type=template&id=2e7d5d73&scoped=true&"
import script from "./mediapage.vue?vue&type=script&lang=js&"
export * from "./mediapage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d5d73",
  null
  
)

export default component.exports